import { apiProxy } from '@/libs/api/apiProxy'
import { GetThemeSummaryResult, PostThemeSummaryResult } from '@/types/school'

export const getThemeSummaryResult = async (
  theme_id: string,
  school_summary_id: string
): Promise<GetThemeSummaryResult> => {
  return await apiProxy.get<GetThemeSummaryResult>(
    `/api/school/themes/${theme_id}/summaries/${school_summary_id}/done`
  )
}

export const postThemeSummaryResult = async (
  theme_id: string,
  answer_score_1: number,
  answer_score_2: number,
  answer_score_3: number,
  school_summary_id: number
): Promise<PostThemeSummaryResult> => {
  return await apiProxy.post<PostThemeSummaryResult>(
    `/api/school/themes/${theme_id}/summaries/${school_summary_id}/done`,
    {
      answer_score_1: answer_score_1,
      answer_score_2: answer_score_2,
      answer_score_3: answer_score_3,
    }
  )
}
